import React from 'react'
import ValidatedTextField from '../commonComponents/validatedTextField'
import './gffStyles.css'

class GrowerFarmField extends React.Component {
    render() {
        return (
            <div className="sectionContainer">
                <ValidatedTextField
                    className="gffSelect"
                    value={this.props.grower ? this.props.grower.name : 'No Grower'}
                    disabled={this.props.disabled}
                    name="fieldDropDown"
                    label="Grower"
                />
                <ValidatedTextField
                    className="gffSelect"
                    value={this.props.farm ? this.props.farm.name : 'No Farm'}
                    disabled={this.props.disabled}
                    name="fieldDropDown"
                    label="Farm"
                />
                <ValidatedTextField
                    className="gffSelect"
                    value={this.props.field ? this.props.field.name : 'No Field'}
                    disabled={this.props.disabled}
                    name="fieldDropDown"
                    label="Field"
                />
            </div>
        )
    }
}

export default (GrowerFarmField)
